<app-head></app-head>

<div class="main-container">
  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Gestion de stock</h2>
    <div class="type-container">
      <div class="type-item" (click)="selectPage('general')">
        Vue Générale
      </div>
      <div class="type-item" (click)="selectPage('detail')">
        Vue Détaillée
      </div>
    </div>
  </div>

  <div class="header-container">
    <h5 style="font-family: 'Lato', sans-serif; font-weight: 600"> Tableau de bord</h5>

    <div class="add-button">
      <button mat-raised-button style="color: #16191e" (click)="createPopin=true">Ajouter un produit</button>
    </div>
  </div>

  <app-stocks-details-page
          *ngIf="selectedStockPage === 'detail'"
          (sendItemToAdd)="openPopin('add', $event)"
          (sendItemRetire)="openPopin('retire', $event)"
          [refreshTable]="triggerRefresh"
  >
  </app-stocks-details-page>

  <app-stocks-general-page
          *ngIf="selectedStockPage === 'general'"
          (sendItemToAdd)="openPopin('add', $event)"
          (sendItemRetire)="openPopin('retire', $event)"
          [refreshTable]="triggerRefresh"
  >
  </app-stocks-general-page>

</div>


<app-popin *ngIf="isPopinOpen" (close)="closePopin()">
  <div class="popin-container">
    <h3 style="font-weight: 900"> {{ selectedItem?.item_name }}</h3>
    <div class="row-container">
      <div class="block-container">
        <span class="title-info">Stock actuel</span>
        <span style="color: #191d20">{{ selectedItem?.actual_quantity }}</span>
      </div>
      <div class="block-container">
        <span class="title-info">Location</span>
        <span style="color: #191d20">{{ selectedItem?.location_id }}</span>
      </div>
    </div>

    <div class="row-container">
      <div class="block-container">
        <span class="title-info">Date Expiration</span>
        <span style="color: #191d20">{{ !!selectedItem ? formatDateToMMDDYYYY(selectedItem.expiration_date) : '' }}</span>
      </div>

      <div class="block-container">
        <span class="title-info">Date de Production</span>
        <span style="color: #191d20">{{ !!selectedItem ? formatDateToMMDDYYYY(selectedItem.production_date) : '' }}</span>
      </div>

    </div>

    <div class="row-container">
      <div class="block-container">
        <span class="title-info">Alertes (jours)</span>
        <span style="color: #191d20">{{ !!selectedItem ? selectedItem.threshold_days: '' }}</span>
      </div>

      <div class="block-container">
        <span class="title-info">Quantité</span>
        <input type="number" class="input-quantity" [(ngModel)]="itemQuantity">
      </div>
    </div>

    <div class="button-container">
      <button mat-flat-button (click)="addStock()" *ngIf="isAddingStock">Ajouter {{ itemQuantity }} unités</button>
      <button mat-flat-button (click)="retireStock()" *ngIf="!isAddingStock">Retirer {{ itemQuantity }} unités</button>
      <button mat-stroked-button (click)="closePopin()">Annuler</button>
    </div>
  </div>
  <div *ngIf="errorMessage">
    <p style="color: red; font-size: 14px">{{ errorMessage }}</p>
  </div>
</app-popin>


<app-popin *ngIf="createPopin" (close)="closePopin()">
  <div class="popin-container">
    <h3 style="font-weight: 900"> Ajouter un produit</h3>
    <div class="row-container">
      <div class="dropdown">
        <input
                type="text"
                class="input-name"
                [(ngModel)]="searchTerm"
                (input)="filterItems()"
                (focus)="showDropdown = true"
                (blur)="hideDropdown()"
                placeholder="Nom du produit "/>

        <ul *ngIf="filteredItems.length > 0 && showDropdown" class="dropdown-list">
          <li *ngFor="let item of filteredItems" (click)="selectItem(item)">
            {{ item.name }}
          </li>
        </ul>
      </div>

      <div class="block-container">
        <span class="title-info">Location</span>
        <input type="number"
               class="input-quantity"
               [min]="1"
               [max]="4"
               [(ngModel)]="locationId">
      </div>

    </div>

    <div class="row-container">
      <div class="block-container">
        <div class="block-container">
          <span class="title-info">Date Production</span>
          <input type="date" class="input-quantity" [(ngModel)]="itemProductionDate">
        </div>
      </div>

      <div class="block-container">
        <div class="block-container">
          <span class="title-info">Date Expiration</span>
          <input type="date" class="input-quantity" [(ngModel)]="itemExpirationDate">
        </div>
      </div>
    </div>
    <div class="row-container">
      <div class="block-container">
        <span class="title-info">Alertes (jours)</span>
        <input type="number" class="input-quantity" [(ngModel)]="itemTresholdDays">
      </div>

      <div class="block-container">
        <span class="title-info">Quantité</span>
        <input type="number"
               class="input-quantity"
               [(ngModel)]="itemQuantity"
        >
      </div>
    </div>

    <div class="button-container">
      <button mat-flat-button (click)="newStock()">Ajouter {{ itemQuantity }} unités</button>
      <button mat-stroked-button (click)="closePopin()">Annuler</button>
    </div>
    <div *ngIf="errorMessage">
      <p style="color: red; font-size: 14px">{{ errorMessage }}</p>
    </div>
  </div>
</app-popin>
